<template>
	<div class="structurer">
		<div class="structurer-heading">
			<Heading title="Estruturadores" />
			<ButtonPrimary label="Adicionar Estruturador" size="md" @click="addStructurer" />
		</div>
		<TableList
			v-if="!isLoading"
			ariaLabel="Lista de Estruturadores"
			:headers="headers"
			:data="data"
			:actions="actions"
			@edit="edit"
			@delete="setUserToDelete"
		/>

		<div class="structurer__loading">
			<SpinnerIcon v-if="isLoading" />
		</div>

		<Modal
			v-if="isModalOpen"
			title="Excluir Estruturador"
			description="Tem certeza que deseja excluir este Estruturador?"
			primaryLabel="Sim"
			secondaryLabel="Não"
			@secondaryClick="toggleModal"
			@primaryClick="confirmDelete"
		/>
	</div>
</template>
<script>
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';
import Heading from '@/components/shared/Heading/Heading.vue';
import TableList from '@/components/shared/Table/TableList.vue';
import ActionsTableEnum from '@/enums/ActionsTableEnum';
import Modal from '@/components/shared/Modal/Modal.vue';
import api from '@/utils/api';

export default {
	name: 'Structurer',
	components: {
		ButtonPrimary,
		SpinnerIcon,
		TableList,
		Heading,
		Modal,
	},
	data: () => ({
		http: api.getInstance().http,
		headers: [
			{
				label: 'Nome',
			},
			{
				label: 'Ações',
			},
		],
		actions: {
			edit: {
				informationText: 'Editar',
				actionIcon: ActionsTableEnum.EDIT,
			},
			delete: {
				informationText: 'Deletar',
				actionIcon: ActionsTableEnum.DELETE,
			},
		},
		data: [],
		isLoading: true,
		isModalOpen: false,
		deleteUserId: null,
	}),
	async created() {
		await this.getList();
	},
	methods: {
		async getList() {
			try {
				const { data } = await this.http(`/structurer`);
				this.data = this.getFields(data);
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		getFields(data) {
			return data.map((field) => {
				return {
					id: field.id,
					name: field.name,
				};
			});
		},
		toggleModal() {
			this.isModalOpen = !this.isModalOpen;
		},
		edit(user) {
			this.$router.push({ path: `/dashboard/structurer/detail`, query: { id: user.id } });
		},
		setUserToDelete(user) {
			this.deleteUserId = user.id;
			this.toggleModal();
		},
		async confirmDelete() {
			try {
				this.toggleModal();
				this.isLoading = true;
				await this.http({
					method: 'Delete',
					url: `/structurer/${this.deleteUserId}`,
				});
				this.$toastr.s('Estruturador deletado com sucesso');
			} catch (error) {
				this.$toastr.e(error.response.data.message);
			} finally {
				await this.getList();
				this.isLoading = false;
			}
		},
		addStructurer() {
			this.$router.push({ path: '/dashboard/structurer/detail' });
		},
	},
};
</script>
<style lang="scss" scoped>
@import './Structurer.scss';
</style>
